import {Injectable} from '@angular/core';
import {RegisterDataTableService} from '../../../core/services/register-data-table.service';
import {StorageService} from '../../../core/services/storage.service';
import {ITableColumn} from '../../../core/common/interfaces/table-column.interface';


@Injectable({
  providedIn: 'root'
})
export class IndexTableService extends RegisterDataTableService {


  constructor(
    storageService: StorageService
  ) {
    super(storageService);
  }


  override getColumns(): ITableColumn[] {
    return [
      {
        name: 'id',
        title: 'Id',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'name',
        title: 'Индекс',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'shortName',
        title: 'Условное обозначение',
        default: true,
        useCustomTemplate: false,
      },
      {
        name: 'fillType',
        title: 'Способ заполнения',
        default: true,
        useCustomTemplate: true,
      },
      {
        name: 'status',
        title: 'Архив',
        useCustomTemplate: true,
        disabled: false,
        default: false,
      },
    ];
  }


}
